<template>

    <section class="w-100 d-flex flex-column">

        <!-- Loading -->
        <loading/>

        <!-- Title Module -->
        <h1 class="order-1">Generate a Token</h1>

        <!-- Token Value -->
        <div v-if="storetoken !== ''" class="order-2">

            <p>{{ storetoken }}</p>

        </div> 

        <!-- Generated Token -->
        <form 
            @submit.prevent="sendData('update')" 
            action="" 
            class="form-nav order-3 my-3" 
            method="post" 
            aria-describedby="Create Store Token" 
            enctype="application/x-www-form-urlencoded" 
            autocomplete="on"
        >

            <select v-if="Object.values(allStores).length > 0" class="form-select mb-2" aria-label="List of Stores" v-model="storename">
                <option v-for="(value, index) in allStores" 
                    :key="value.id"
                    :data-storeid="value.id"
                    :value="value.name"
                    @click="getStoreId($event)"
                >{{ value.name }}</option>
            </select>

            <div v-if="Object.values(allActions).length > 0" 
                class="d-flex flex-row">

                <span v-for="(value, index) in allActions" 
                :key="index"  
                @click="addAction($event)" 
                :class="`actionitems order-${index}`" 
                :data-value="value"
                style="margin-right:2.5%;"    
                >
                    {{ value }}
                </span>

            </div>

            <button type="submit" class="btn btn-primary float-end my-3" :disabled="disabled">{{ btntext }}</button>

        </form>

        <!-- Response Messages -->
        <div class="order-4 responsebasemessage" ref="responsebasemessage">

            <list-message/>

        </div>

        <!-- Check List -->
        <template v-if="Object.values(allStoresList).length > 0">

            <!-- Page List Render-->
            <table-element :classname="['table-striped', 'mt-3', 'order-3']">

                <!-- THead -->
                <template #thead>
                    <tr>
                        <th scope="col">Id</th>
                        <th scope="col">Store</th>
                        <th scope="col">Email</th>
                        <th scope="col">Actions</th>
                    </tr>
                </template>

                <!-- Tbody -->
                <template #tbody>

                    <tr v-for="(value, index) in allStoresList" :key="value.id" :data-referid="index">
                        
                        <th scope="row">{{ value.id }}</th>
                        <td>{{ value.name }}</td>
                        <td>{{ value.email }}</td>
                        <td>{{ setActions(value.actions) }}</td>

                    </tr>

                </template>

            </table-element>

        </template>

    </section>

</template>
<script>

import fetchData from './../../fetchData';
import ListMessage from './../elements/ListMessageElement.vue';
import Loading from './../elements/LoadingElement.vue';
import Table from './../elements/TableElement.vue';

'use strict';

    export default{
        name: 'StoresAdmin',
        props: {

            csrftolken:{
                type: String,   
                required: true
            },
            storegenerated:{
                type: String,   
                required: true
            },
            storedata:{
                type: String,   
                required: true
            },

        },
        data: () => {

            return{

                activeclass: 'd-flex',
                disabled: false,
                btntext: 'Submit',
                storename: '',
                storeaction: [],
                storeid: '',
                storetoken: '',
                allStores:{},
                allActions: {},
                allData: {},
                allStoresList: {},

            }

        },
        created(){

            //Get Store Data
            this.allData = JSON.parse(this.storedata);

            //Set Stores List
            this.allStores = this.allData.stores;

            //Set Actions List
            this.allActions = this.allData.actions;

            //Set Store List
            this.allStoresList = this.allStores;

        },
        methods:{

            setActions(actiondata){

                return actiondata !== null ? JSON.parse(actiondata).join(", ") : "";

            },
            getStoreId(element){

                //Set Store Id
                this.storeid = element.target.getAttribute('data-storeid');

                return this.storeid;

            },
            addAction(element){

                //Check Element
                if(!this.storeaction.includes(element.target.getAttribute('data-value'))){

                    //Push Value
                    this.storeaction.push(element.target.getAttribute('data-value'));

                    //Set Active Class
                    element.target.classList.add('activeaction');

                }else{

                    //Get Index from value on Action List
                    let indexAction = this.storeaction.indexOf(element.target.getAttribute('data-value'));

                    //Remove item from Action List
                    this.storeaction.splice(indexAction, 1);

                    //Remove Active Class
                    element.target.classList.remove('activeaction');

                }

            },
            removeResponseMessages(time = 5000){

                setTimeout(function(){

                    //Remove active class
                    document.querySelector('.responsebasemessage').classList.remove('d-flex');
                    document.querySelector('.responsebasemessage').classList.remove('successmessage');
                    document.querySelector('.responsebasemessage').classList.remove('errormessage');

                    //Remove children elements
                    let ul = document.querySelector('.responsebasemessage').children;

                    [...ul[0].children].forEach((valli) => {

                        //Remove Elements
                        valli.remove();

                    });

                }, time);

            },
            dataStructureResponse(responseObject){

                //Get Key and Value
                let entries = Object.entries(responseObject);

                //Loop response conditional
                for(const [key, value] of entries){

                    switch(key)
                    {

                        case 'attListData':

                            //Clean Variable
                            this.storename = '';
                            this.storeaction = [];
                            this.storeid = '';

                            //Get All Checkbox Actions
                            let allCheckboxActions = [...document.querySelectorAll('.actionitems')];

                            //Clean Checkbox
                            allCheckboxActions.forEach((value) => {

                                //Remove active class
                                value.classList.remove('activeaction');

                            });

                            //Set Store Token
                            this.storetoken = value[0];

                            //Set Store List
                            this.allStoresList = value[1];

                            //Enabled Submit
                            this.disabled = false;

                        break;

                        case 'successMessage':
                        case 'errorMessage':
                            
                            //Add active Class
                            this.$refs.responsebasemessage.classList.add(this.activeclass);
                            this.$refs.responsebasemessage.classList.add(key.toLowerCase());

                            //Set Messages List
                            value.forEach((valmessage) => {

                                //Element for append
                                let li = `<li class="list-group item my-1">${valmessage}</li>`;

                                //Append Element
                                $(li).appendTo(this.$refs.responsebasemessage.children);

                            });
                            

                        break;

                    }

                }

                //Remove Base Response Message
                this.removeResponseMessages();

                return;

            },
            errorConditional(message, storeserror = false){

                //Send Message
                alert(message);

                //Desactive Loading
                document.querySelector('.loadingbase').classList.remove('d-flex');

                //Get All Checkbox Actions
                let allCheckboxActions = [...document.querySelectorAll('.actionitems')];

                //Check type of error
                if(storeserror){

                    this.storeaction = [];

                    //Clean Checkbox
                    allCheckboxActions.forEach((value) => {

                        //Remove active class
                        value.classList.remove('activeaction');

                    });

                }

                //Enabled Submit
                this.disabled = false;

            },
            sendData(formaction){

                //Active Loading
                document.querySelector('.loadingbase').classList.add('d-flex');

                //Disabled Submit
                this.disabled = true;

                //Set Route
                let method;
                let urlmethod;
                let dataForm = {}; 

                switch(formaction)
                {

                    case 'insert':

                        method = 'POST';
                        urlmethod = '';

                    break;

                    case 'update':

                        method = 'PUT';
                        urlmethod = this.storegenerated;

                        //Clean StoreToken
                        this.storetoken = '';

                        //Set Form Data
                        dataForm.storeid= this.storeid;
                        dataForm.storename = this.storename.trim();
                        dataForm.storeaction = this.storeaction;

                        //Check Store Choosed
                        if(dataForm.storename === '' || dataForm.storeid === ''){

                            //Set Error Conditional
                            this.errorConditional('Favor selecionar a Loja para gerar o Token', true);

                            return;

                        }

                        //Check Action List
                        if(dataForm.storeaction.length === 0 && dataForm.storename !== ""){

                            //Set Error Conditional
                            this.errorConditional('Favor definir Actions para a Loja');

                            return;

                        }

                    break;

                    case 'softdelete':

                        method = 'PUT';
                        urlmethod = '';

                    break;

                    case 'restoresoftdelete':

                        method = 'PUT';
                        urlmethod = '';

                    break;

                    case 'delete':

                        method = 'DELETE';
                        urlmethod = '';

                    break;

                    case 'active':

                        method = 'PUT';
                        urlmethod = '';

                    break;

                }

                //Send Data
                let response = fetchData.structureTosendData(urlmethod, dataForm, this.csrftolken, method);

                //Check Data Form
                if(Object.keys(dataForm).length > 0){

                    //Check Response
                    response.then((value) => {

                        //Desactive Loading
                        document.querySelector('.loadingbase').classList.remove('d-flex');

                        //Generate a Response
                        return this.dataStructureResponse(value);

                    }).catch((error) => {

                        //Desactive Loading
                        document.querySelector('.loadingbase').classList.remove('d-flex');

                        //Enabled Submit
                        this.disabled = false;

                        throw new Error(error);

                    });

                }else{

                    //Send Message
                    alert('Por favor apenas enviar dados válidos');

                    //Desactive Loading
                    document.querySelector('.loadingbase').classList.remove('d-flex');

                    //Enabled Submit
                    this.disabled = false;

                    return;

                }

            },

        },
        computed:{

            computedStoreId(){

                return this.storeid;

            },
            computedStoreName(){

                return this.storename;

            },
            computedStoreAction(){

                return this.storeaction;

            },
            computedStoreToken(){

                return this.storetoken;

            },
            computedAllStoreList(){

                return this.allStoresList;

            }

        },
        watch:{

            computedStoreAction(){},
            computedStoreId(){},
            computedStoreName(){},
            computedStoreToken(){},
            computedAllStoreList(){}

        },
        components:{

            listMessage: ListMessage,
            loading: Loading,
            tableElement: Table

        }

    }

</script>